import PageTitle from '@components/Components/Reusables/PageTitle';
import P from '@components/Components/Reusables/Typography/P';
import Container from '@mui/material/Container';
import Link from 'next/link';
import { Fragment } from 'react';

const Heading = ({children}) => <PageTitle color="primary" as="h2">{children}</PageTitle>

const listItems = [
	{
		title: 'Do I have to pay for delivery and collection?',
		custom: () => (
			<>
				<P>
					Yes - and there are lots of different rates to choose from so you get the one that fits your budget the best. On every day of the week we offer standard deliveries that arrive between 8am and 6pm, and timed slots too, when it’s crucial to get your furniture delivered at a specific time.
				</P>

				<P>The <Link className="pointer primary-font-color fw-semi-bold" href="/#shippingCalculator">postcode calculator</Link> on our homepage allows you to see exactly how much transport costs will be in your area.</P>
			</>
		)
	},
	{
		title: 'What are your opening hours?',
		description: "We're open every day from 8am to 8pm, and deliveries can also be scheduled any time of the day and night.",
	},
	{
		title: 'How do you deliver your furniture?',
		description: "Our furniture arrives wrapped and on pallets/in cages. This ensure all product's you've ordered stay very clean and are simple to transport in large batches."
	},
	{
		title: 'I require linen in a specific colour, do you only have black and white available?',
		description: "No - we can source different colour linens for you, just let us know and we'll simply add them to your order"
	},
	{
		title: 'How many chairs will fit in my room?',
		description: 'This can be worked out using the footprint of each chair and the size of your venue. You can take a look at our website to check these numbers, or feel free to get in touch with our in-house CAD expert who can offer more detail on set up of your furniture.'
	},
	{
		title: 'I want delivery at an unsocial time. Can you help?',
		description: 'We certainly can. Our extensive transport fleet travel throughout London on a daily basis and can transport your furniture to the city and beyond at a time that suits you.'
	},
	{
		title: 'I want delivery on the weekend - is this possible?',
		description: "Yes! That's no problem, because we offer same day deliveries to London any time of the week, day or night - for no extra charge."
	},
	{
		title: 'Are bank holidays extra?',
		description: 'Yes. Bank holiday rates attract a small charge, but if we deliver/collect either side of the holiday then you pay only our standard rates.'
	},
	{
		title: 'My requirements are complex, can you help?',
		description: "Without a doubt! We meet many complex orders, from those featuring lots of furniture, to those with differing delivery and collection times and locations. We're experts in getting you what you need when you need it, and also have in-house CAD experts who can offer advice on the type of furniture that'll suit your event space."
	},
	{
		title: 'Can you deliver and collect on the same day?',
		description: "That's no problem at all. We regularly drop off and pick up our furniture in one day, especially for events going on in London."
	},
	{
		title: 'Do you have these chairs in another colour?',
		description: 'We offer many different finishes in terms of chair colour. Our polyprop, conference and operators chairs all come in black or blue, and if you’d like a lighter colour, why not try our white folding plastic chairs.'
	},
	{
		title: 'Do you hire to companies? Do you hire to business?',
		description: 'Yes to both. In short we hire to anyone that needs furniture rental. From huge global companies, to SMEs, and private customers too.'
	},
	{
		title: "Once I've placed my order, will I have one point of contact?",
		description: "Yes. Having one agent as your 'go-to person' is a prime feature of our furniture hire service. We make sure all your needs are met by one agent, which keeps communication very smooth."
	},
	{
		title: 'I need to place chairs in lines, are there any health and safety regulations?',
		description: 'Very likely. Many of our customers are required to fix chairs in neat rows to comply with health and safety policies. This ensures there are clear exit routes during evacuations. We have linking loops that allow you to secure plastic and conference seating efficiently and affordably!'
	},
	{
		title: 'Can I link your chairs together?',
		description: 'Yes - very easily! We stock very robust linking loops that are clicked on to our plastic and stacking chairs in seconds. These not only keep chairs looking neat, but also keep lines of exit and entry open in case of fire drills and evacuation - an important health and safety feature.'
	},
	{
		title: 'Will your tables damage my floor?',
		description: 'No - Our table ranges have been designed to be as kind to floors as possible, with feet covered in protective caps, or manufactured from floor-friendly materials.'
	},
	{
		title: 'Can your furniture be used outside?',
		description: 'Several of our products can be used outside thanks to their weatherproof veneer. These include our polyprop and plastic chairs, as well as our chrome bistro table, in addition to our chrome poseur table and aluminium high bar stool.'
	},
	{
		title: 'Will your furniture arrive clean?',
		description: 'Yes. Each time our furniture is returned to the warehouse we clean it thoroughly, quality check it and then vacuum wrap it so it stays this way!'
	},
	{
		title: 'I want a lot of furniture - can you supply stock images',
		description: 'Yes. Please contact us by email or telephone to see more images of our products. Our website also has 3D images and videos of our ranges so you can see them from different perspectives.'
	},
	{
		title: 'Where are you based?',
		description: 'We are based in London, and have two large depots in the city that are perfectly situated for our table and chair hire customers. We also have several warehouses in other major UK cities and can deliver next day throughout the UK.'
	},
	{
		title: 'Can I meet a member of your team?',
		description: "Yes. We have an experienced customer service team who meet regularly with many of our clients. Please give us a call if you'd like to meet one of our agents in-person."
	},
	{
		title: 'Are the pictures on your website the actual products you supply?',
		description: 'Yes. What you see is what you get! We take professional shots of our products and upload them using the latest software so you get a spot-on impression of what they look like.'
	},
	{
		title: 'I need to speak to a sales agent, is this possible?',
		description: "Yes! To speak to a sales agent directly, just call the number on our homepage and you'll get straight through to us. We are also fully e-commerce so you can complete your entire order online, and you can also ask us any questions via our website too."
	}
];

export default function FirstTimeHiringGuide() {

    return (
        <div>
			<PageTitle className="m-0 ml-2" as="h1">First Time Hiring Guide</PageTitle>
			<Container className="mb-5">
				<P>Furniture rental allows you to obtain all the items you need for any event at a fraction of the cost of purchasing them.</P>

		

				{listItems.map(item => (
					<Fragment key={item.title}>
						<Heading>{item.title}</Heading>
						{item?.custom ? item.custom() : <P>{item.description}</P>}
					</Fragment>
				))}

			</Container>
        </div>
    );
}
